(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["auth0Helper"] = factory();
	else
		root["auth0Helper"] = root["auth0Helper"] || {}, root["auth0Helper"]["login"] = factory();
})(self, () => {
return 